export default __webpack_public_path__ + "59c190ca9a96958172427044a9fd5b05.png";